import ApiService from "@/common/api/api.service";

const SqlAdminService = {
  async executarSql(query, isReadOnly = false) {
    const { data } = await ApiService.post("SqlAdmin/executar", {
      query,
      isReadOnly,
    });
    return data;
  },
};

export default SqlAdminService;

